import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_8em2suwmrj: FaireBrandEntity = {
  token: "b_8em2suwmrj",
  type: "brand",
  name: "Laurel's Coffee",
  avatarUrl:
    "https://cdn.faire.com/fastly/f13e9a43464f5aa6da9b0a17dad357f3be26861078507dc6606a9e8a065f7261.jpeg",
  bannerUrl:
    "https://cdn.faire.com/fastly/c5621ca5f1c85ca18aa3f903a33c95d82aee19becf1cf64e6d2882ddeaef938b.jpeg",
  logoUrl:
    "https://cdn.faire.com/fastly/f13e9a43464f5aa6da9b0a17dad357f3be26861078507dc6606a9e8a065f7261.jpeg",
  heroImageUrl:
    "https://cdn.faire.com/fastly/c5621ca5f1c85ca18aa3f903a33c95d82aee19becf1cf64e6d2882ddeaef938b.jpeg",
  location: "Los Angeles, CA, USA",
  minimumOrderDollars: 0,
  rating: 4.3,
  reviewCount: 3,
  isInsider: true,
  description:
    "We're Laurel's Coffee - the world's first 100% organic, regenerative, A2 dairy ready-to-drink latte.\nOur founder was looking for a gut-friendly solution that would provide indulgence, creaminess and complexity to ready-to-drink lattes - similar to what you'd find at your local coffee shop. After months of formulation and R&D, she developed just that. \nOur dairy is sourced from Alexandre Family Farms, the only certified regenerative farm in the US, where they've pasture-raised happy, healthy, A2 cows for over four generations.",
  meta: {
    source: "api",
    importedAt: "2026-08-12T22:03:41.672Z",
    importedBy: "entity-db-cli",
  },
};
